import React from "react";
import ReactPlayer from "react-player";

export default function VideoPlayer(props) {
  // PROPS ARE COMING FROM ProductLandings
  const { sect } = props;
  return (
    <>
      {sect.contentVideoUrl.map((url, index) => {
        return (
          <div className={sect.videoType} key={index}>
            <ReactPlayer width="100%" height="100%" url={url} controls={true} />
          </div>
        );
      })}
    </>
  );
}
